import Badge from '@components/atoms/Badge'
import { IconHint } from '@components/molecules/IconHint'

import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('roster_board')

export function AssignOnlyBadge() {
  return (
    <IconHint label={t('assign_only_hint')}>
      <Badge
        color="muted"
        leadingIcon="user-square"
        tabIndex={0}
        role="note"
        aria-label={t('assign_only_label')}
        className="tw:cursor-help tw:focus:outline-hidden tw:focus-visible:ring-2 tw:focus-visible:ring-primary-400"
      >
        {t('assign_only_label')}
      </Badge>
    </IconHint>
  )
}
